import vuetify from '@/main';
import MainDraftEditModal from '@/modules/billing/review/editDraft/MainDraftEditModal.vue';
import TrustDeposit from '../accounting/TrustDeposit.vue';
import ClientLedes from './client/ClientLedes.vue';
import ClientInfo from './client/ClientInfo.vue';
import MatterLedes from '../matters/MatterLedes.vue';
import MatterNetDocs from './matter/MatterNetDocs.vue';
import MatterSplitBilling from './matter/MatterSplitBilling.vue';
import CreateClient from './client/CreateClient.vue';
import ClientsPage from './clientsList/ClientsPage.vue';
import CreateMatter from '../matters/CreateMatter.vue';
import CreateChargeModal from '../fixedfees/components/CreateChargeModal.vue';
import MatterSettlement from '../matters/settlement/MatterSettlement.vue';
import MatterLiensTab from '../matters/MatterLiensTab.vue';
import MatterFeeRecipientsTab from '../matters/MatterFeeRecipientsTab.vue';
// Registers the <ll-matter-info-vue> directive (internConversion flag). It lives
// in a .ts module, so it must be imported explicitly — app.js's require.context
// auto-loader only scans .js files.
import './matter/matterInfoVue.directive';
angular.module('leanlaw').config(['$stateProvider', function ($stateProvider) {
  function addClientMatterRoutes(root) {
    $stateProvider.state(`${root}.newMatter`, {
      url: '/newMatter',
      params: {
        matter: {},
        clientId: null,
        methodOverride: null
      },
      views: {
        edit: {
          template: require('../matters/views/create.html'),
          controller: 'MattersCreateCtrl'
        }
      }
    }).state(`${root}.matter2`, {
      url: '/matter2',
      params: {
        matter: {},
        clientId: null,
        methodOverride: null
      },
      views: {
        edit: {
          ...vuetify(CreateMatter)
        }
      }
    }).state(`${root}.newMatter.client`, {
      url: '/client',
      params: {
        popup: true,
        methodOverride: null
      },
      views: {
        edit: {
          template: require('../matters/views/client-popup.html')
        },
        //nested view
        [`popup@${root}.newMatter.client`]: {
          template: require('../matters/views/client.html'),
          controller: 'ClientEditCtrl'
        }
      }
    }).state(`${root}.client2`, {
      url: '/client2',
      params: {
        methodOverride: null
      },
      views: {
        edit: {
          ...vuetify(CreateClient)
        }
      }
    }).state(`${root}.newClient`, {
      url: '/newClient',
      params: {
        popup: true
      },
      views: {
        edit: {
          template: require('../matters/views/client-popup.html')
        },
        //nested view
        [`popup@${root}.newClient`]: {
          template: require('../matters/views/client.html'),
          controller: 'ClientEditCtrl'
        }
      }
    }).state(`${root}.newClient2`, {
      url: '/newClient2',
      views: {
        edit: {
          ...vuetify(CreateClient)
        }
      }
    }).state(`${root}.connect`, {
      url: '/connect/{id}',
      params: {
        clientId: null,
        matterId: null
      },
      views: {
        edit: {
          template: require('../accounting/views/matter.edit.html'),
          controller: 'MatterAccountingEditCtrl'
        }
      }
    }).state(`${root}.trust`, {
      url: '/trust/{id}',
      params: {
        clientId: null,
        matterId: null
      },
      views: {
        edit: {
          template: require('../accounting/views/trust.matter.html'),
          controller: 'TrustMatterCtrl'
        }
      }
    }).state(`${root}.client`, {
      url: '/client/{id}',
      redirectTo: `${root}.client.view`,
      views: {
        '@': {
          template: require('./views/client.html'),
          controller: 'ClientCtrl'
        }
      }
    }).state(`${root}.client.view`, {
      url: '/view',
      redirectTo: `${root}.client.view.overview`,
      template: require('./client/views/clientView.html'),
      controller: 'ClientViewCtrl'
    }).state(`${root}.client.view.info`, {
      url: '/info',
      ...vuetify(ClientInfo)
    }).state(`${root}.client.view.overview`, {
      url: '/overview',
      template: require('./client/views/clientOverview.html'),
      controller: 'ClientOverviewCtrl'
    }).state(`${root}.client.view.billingActivity`, {
      url: '/billingActivity',
      template: require('./client/views/clientBilling.html'),
      controller: 'ClientBillingActivityCtrl'
    }).state(`${root}.client.view.billingActivity.edit`, {
      url: '/edit',
      views: {
        [`@${root}.client.view`]: vuetify(MainDraftEditModal)
      },
      params: {
        invoiceId: null,
        invoice: null,
        onlyViewInvoice: null
      }
    }).state(`${root}.client.view.leanAlign`, {
      url: '/leanAlign',
      template: require('./client/views/leanAlign.html'),
      controller: 'ClientLeanAlign'
    }).state(`${root}.client.view.ledes`, {
      url: '/ledes',
      ...vuetify(ClientLedes)
    }).state(`${root}.client.view.activity`, {
      url: '/activity',
      template: require('./client/views/clientActivity.html'),
      controller: 'ClientActivityCtrl'
    }).state(`${root}.client.matter`, {
      url: '/matter/{matterId}',
      redirectTo: `${root}.client.matter.info`,
      views: {
        [`@${root}.client`]: {
          template: require('./matter/views/matterView.html'),
          controller: 'MatterViewCtrl'
        }
      }
    }).state(`${root}.client.matter.info`, {
      url: '/info',
      template: require('./matter/views/matterInfo.html'),
      controller: 'MatterInfoCtrl'
    }).state(`${root}.client.matter.overview`, {
      url: '/overview',
      template: require('./matter/views/matterOverview.html'),
      controller: 'MatterOverviewCtrl'
    }).state(`${root}.client.matter.billingActivity`, {
      url: '/billingActivity',
      template: require('./matter/views/matterBilling.html'),
      controller: 'MatterBillingActivityCtrl'
    }).state(`${root}.client.matter.billingActivity.edit`, {
      url: '/edit',
      views: {
        [`@${root}.client.matter`]: vuetify(MainDraftEditModal)
      },
      params: {
        invoiceId: null,
        invoice: null,
        onlyViewInvoice: null
      }
    }).state(`${root}.client.matter.access`, {
      track: 'Matter: Access',
      url: '/access',
      template: require('../matters/views/matter-access.html'),
      controller: 'MatterAccessCtrl'
    })
    // Not listed in matterView.html's vm.tabs (matter-view.ctrl.js) -
    // deliberately unlisted/URL-only. Some team members still use this
    // as an internal tool (reassign a matter to a different client, or
    // merge with another matter); it's not meant to be discoverable in
    // the normal tab bar.
    .state(`${root}.client.matter.assign`, {
      url: '/assign',
      template: require('../matters/views/matter-assign.html'),
      controller: 'MatterAssignCtrl'
    }).state(`${root}.client.matter.netdocs`, {
      url: '/netdocs',
      ...vuetify(MatterNetDocs)
    }).state(`${root}.client.matter.splitBilling`, {
      url: '/splitBilling',
      ...vuetify(MatterSplitBilling)
    }).state(`${root}.client.matter.fixed`, {
      track: 'Matter: Fixed',
      url: '/fixed',
      template: require('../matters/views/matter-fixed.html'),
      controller: 'MatterFixedCtrl'
    }).state(`${root}.client.matter.fixed.edit`, {
      url: '/edit',
      views: {
        [`@${root}.client.matter`]: vuetify(MainDraftEditModal)
      },
      params: {
        invoiceId: null,
        invoice: null,
        onlyViewInvoice: null
      }
    }).state(`${root}.client.matter.fixed.addStandard`, {
      url: '/addStandard',
      views: {
        edit: {
          template: require('../matters/views/add-standard.html'),
          controller: 'AddStandardCtrl'
        }
      }
    }).state(`${root}.client.matter.fixed.charge`, {
      url: '/edit/{chargeId}',
      views: {
        edit: {
          ...vuetify(CreateChargeModal)
        }
      },
      params: {
        chargeId: null,
        ledes: false,
        showAllocation: false,
        showClientMatter: false
      }
    }).state(`${root}.client.matter.billing`, {
      url: '/billing',
      template: require('../matters/views/matter-billing.html'),
      controller: 'MatterBillingCtrl'
    }).state(`${root}.client.matter.billing.connect`, {
      url: '/connect',
      params: {
        clientId: null,
        matterId: null,
        message: null,
        onCancel: null
      },
      views: {
        edit: {
          template: require('../accounting/views/matter.edit.html'),
          controller: 'MatterAccountingEditCtrl'
        }
      }
    }).state(`${root}.client.matter.billing.trust`, {
      url: '/trust',
      params: {
        clientId: null,
        matterId: null
      },
      views: {
        edit: {
          template: require('../accounting/views/trust.matter.html'),
          controller: 'TrustMatterCtrl'
        }
      }
    }).state(`${root}.client.matter.billing.deposit`, {
      track: 'Trust: Deposit',
      url: '/deposit',
      views: {
        edit: {
          ...vuetify(TrustDeposit)
        }
      }
    }).state(`${root}.client.matter.ledes2`, {
      track: 'Matter: LEDES',
      url: '/ledes2',
      ...vuetify(MatterLedes)
    }).state(`${root}.client.matter.ledes`, {
      track: 'Matter: LEDES',
      url: '/ledes',
      template: require('../matters/views/matter-ledes.html'),
      controller: 'MatterLedesCtrl'
    }).state(`${root}.client.matter.liens`, {
      track: 'Matter: Liens',
      url: '/liens/{lienId}',
      params: {
        lienId: {
          value: null,
          squash: true
        }
      },
      ...vuetify(MatterLiensTab, undefined, 'edit')
    }).state(`${root}.client.matter.feeRecipients`, {
      track: 'Matter: Fee Recipients',
      url: '/fee-recipients',
      ...vuetify(MatterFeeRecipientsTab, undefined, 'edit')
    }).state(`${root}.client.matter.settlement`, {
      track: 'Matter: Settlement',
      url: '/settlement',
      ...vuetify(MatterSettlement, undefined, 'edit')
    }).state(`${root}.client.matter.settlement.deposit`, {
      track: 'Trust: Deposit',
      url: '/deposit',
      views: {
        edit: {
          ...vuetify(TrustDeposit)
        }
      }
    });
  }
  $stateProvider.state('clients', {
    url: '/clients',
    template: require('./views/clients.html'),
    controller: 'ClientsCtrl'
  })
  // The Vue Clients list, for fizzyLiftingDrink accounts. It takes over /clients
  // when the flag is retired.
  .state('clients2', {
    url: '/clients2',
    ...vuetify(ClientsPage, undefined, 'edit')
  }).state('matters-next', {
    url: '/matters-next',
    template: require('./views/matters.html'),
    controller: 'MattersNextCtrl'
  });

  // Same routes for clients and matters tabs. clients2 gets its own copy so the
  // client page's Back and post-create redirects return to the list they came from.
  addClientMatterRoutes('clients');
  addClientMatterRoutes('clients2');
  addClientMatterRoutes('matters-next');

  // Special route to create fixed fee from the shortcut menu
  $stateProvider.state(`matters-next.charge`, {
    url: '/charge',
    views: {
      edit: {
        ...vuetify(CreateChargeModal)
      }
    },
    params: {
      chargeId: null,
      ledes: false,
      showAllocation: false,
      showClientMatter: true,
      createFixedFee: true,
      methodOverride: null,
      entryPoint: null
    }
  });
}]);